if (!customElements.get('gtc-shipping-countdown')) {
  class GtcShippingCountdown extends HTMLElement {
    constructor() {
      super(); // Call the parent class's constructor function
    }

    connectedCallback() {

      // Using requestAnimationFrame to ensure the element is fully rendered before running the code
      requestAnimationFrame(() => {
        this.originalCountdownText = this.innerHTML;
        // Find the element with the attribute 'data-shipping-data', get its text content,
        // parse it as JSON, and store the result in a property
        this.shippingData = window.gtc.countdown.shippingData;

        this.settings = {
          hideIfZero: this.hasAttribute('hide-if-zero'),
        };

        // When the custom element is inserted into the DOM, the connectedCallback lifecycle method is called
        // Here, we call the calculateCountdown method which calculates the countdown based on the shipping data
        this.calculateCountdown();
      });
    }

    datesToExclude() {
      const datesToExcludeArray = window.gtc.countdown.datesToExclude;
      let datesToExclude = [];

      datesToExcludeArray.forEach((line) => {
        // Check if the line contains a range of dates
        if (line.includes('->')) {
          // If it does, split the line into start and end dates
          const [start, end] = line.split('->').map((dateStr) => {

            // For each date, split it into day, month, and year,
            // then create a new Date object
            const [day, month, year] = dateStr.trim().split('-');
            return new Date(year, month - 1, day);
          });

          // if start or end date is more than 2 years in the future, return null
          if ((start.getTime() - new Date().getTime()) / (1000 * 3600 * 24 * 365) > 5 || (end.getTime() - new Date().getTime()) / (1000 * 3600 * 24 * 365) > 5) {
            return null;
          }

          // Loop from the start date to the end date
          for (
            let dt = new Date(start);
            dt <= end;
            dt.setDate(dt.getDate() + 1)
          ) {
            // For each date in the range, add a new Date object to the datesToExclude array
            datesToExclude.push(new Date(dt));
          }
        } else {
          // If the line does not contain a range, it's a single date
          // Split it into day, month, and year, then create a new Date object
          
          const [day, month, year] = line.split('-');
          datesToExclude.push(new Date(year, month - 1, day));
        }
      });

      // Remove duplicates from the datesToExclude array
      datesToExclude = Array.from(new Set(datesToExclude.map(date => date.getTime()))).map(time => new Date(time));

      // Sort the datesToExclude array in ascending order
      datesToExclude.sort((a, b) => a.getTime() - b.getTime());

      // Get the last date in the datesToExclude array
      let lastDate = datesToExclude[datesToExclude.length - 1] || new Date();

      // Define an array of days of the week
      const days = [
        'sunday',
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
      ];

      // If there are more than 7 dates to exclude, return the datesToExclude array
      if (datesToExclude.length > 7) {
        return datesToExclude;
      }


      // Get the day of the week of the last date
      let nextAvailableDay = lastDate.getDay();

      // Initialize a counter for blank days
      let blankDaysCount = 0;

      // Loop through the next 7 days
      for (let i = 0; i < 7; i++) {
        // Calculate the next day of the week
        nextAvailableDay = (nextAvailableDay + i) % 7;

        // Get the shipping time for the next available day
        const shippingTime = this.shippingData[days[nextAvailableDay]];

        // If the shipping time is undefined or blank, increment the blank days counter
        if (shippingTime === undefined || shippingTime.trim() === '') {
          blankDaysCount++;
        }
      }

      // For each blank day, add a new date to the datesToExclude array
      for (let i = 0; i < blankDaysCount; i++) {
        lastDate = new Date(
          lastDate.getFullYear(),
          lastDate.getMonth(),
          lastDate.getDate()
        );
        datesToExclude.push(lastDate);
      }

      // For each day in the shipping data
      for (let day in this.shippingData) {
        // If the shipping time for that day is undefined or blank
        if (
          this.shippingData[day] === undefined ||
          this.shippingData[day].trim() === ''
        ) {
          // Calculate the date of the next occurrence of that day of the week
          let blankDay = days.indexOf(day);
          let blankDate = new Date(
            lastDate.getFullYear(),
            lastDate.getMonth(),
            lastDate.getDate() + ((blankDay + 7 - lastDate.getDay()) % 7)
          );

          // Add that date to the datesToExclude array
          datesToExclude.push(blankDate);
        }
      }

      // Return the datesToExclude array
      return datesToExclude;
    }

    calculateCountdown() {
      // Get the current date and time
      var currentDate = new Date();

      // Define an array of days of the week
      var days = [
        'sunday',
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
      ];

      // Initialize a counter for the loop
      var loopCount = 0;

      // Initialize a flag to indicate whether a shipping day has been found
      var found = false;

      // Get the dates to exclude from the countdown
      var datesToExclude = this.datesToExclude();

      // Loop until a shipping day is found
      while (!found) {
        // Calculate the next date by adding the loop count to the current date
        var nextDate = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate() + loopCount
        );

        // Get the day of the week for the next date
        var nextShippingDay = nextDate.getDay();

        // Get the shipping time for the next shipping day
        var shippingTime = this.shippingData[days[nextShippingDay]];

        // If a shipping time is defined for the next shipping day
        if (shippingTime !== undefined && shippingTime.trim() !== '') {
          // Get the current time
          var currentTimeInMinutes =
            currentDate.getHours() * 60 + currentDate.getMinutes();
          var shippingTimeInMinutes =
            parseInt(shippingTime.split(':')[0]) * 60 +
            parseInt(shippingTime.split(':')[1]);

          // If the next date is not today or the current time is before the shipping time
          if (
            loopCount !== 0 ||
            currentTimeInMinutes <= shippingTimeInMinutes
          ) {
            // If the next date is not in the dates to exclude
            if (
              !datesToExclude.some(
                (dateExclude) =>
                  dateExclude.getFullYear() === nextDate.getFullYear() &&
                  dateExclude.getMonth() === nextDate.getMonth() &&
                  dateExclude.getDate() === nextDate.getDate()
              )
            ) {
              // Set the found flag to true
              found = true;
            }
          }
        }

        // Increment the loop count
        loopCount++;
      }

      // If a shipping day was found
      if (found) {
        // Split the shipping time into hours and minutes
        var shippingTimeParts = shippingTime.split(':');

        // Set the hours and minutes of the next date to the shipping time
        nextDate.setHours(shippingTimeParts[0], shippingTimeParts[1], 0, 0);

        // Initialize a variable for the shipping
        var shipping;
        var delivery;

        // Get the current day of the week
        var currentDay = currentDate.getDay();
        var estimatedDeliveryDate = new Date(
          nextDate.getTime() +
          window.gtc.countdown.delivery.days * 24 * 60 * 60 * 1000
        );
        var maxDeliveryDate = new Date(
          currentDate.getTime() +
          window.gtc.countdown.delivery.maxDays * 24 * 60 * 60 * 1000
        );

        if (
          window.gtc.countdown.delivery.maxDays > 0 &&
          estimatedDeliveryDate > maxDeliveryDate
        ) {
          // Remove the element if the estimated delivery date is greater than the max delivery date
          this.remove();
          return;
        } else {
          delivery =
            window.gtc.countdown.strings[days[estimatedDeliveryDate.getDay()]] +
            ' ' +
            estimatedDeliveryDate.toLocaleDateString();
        }

        // If the next shipping day is within the next week
        if (loopCount <= 7) {
          // If the next shipping day is today
          if (nextShippingDay === currentDay) {
            shipping = window.gtc.countdown.strings.today;
          }
          // If the next shipping day is tomorrow
          else if (nextShippingDay === (currentDay + 1) % 7) {
            shipping = window.gtc.countdown.strings.tomorrow;
          }
          // If the next shipping day is later in the week
          else {
            shipping = window.gtc.countdown.strings[days[nextShippingDay]];
          }
        }
        // If the next shipping day is more than a week away
        else {
          shipping =
            window.gtc.countdown.strings[days[nextShippingDay]] +
            ' ' +
            nextDate.toLocaleDateString();
        }

        // If no shipping day was found
        if (!found) {
          console.error('No available shipping day found in shippingData');
        }
        // If a shipping day was found
        else {
          // Start the countdown to the next shipping day
          this.startCountdown(nextDate, shipping, delivery);
        }
      }
    }

    getTimeForDay(date, day, time) {
      // Create a new date object from the provided date
      var newDate = new Date(date.getTime());

      // Set the date of the new date object to the next occurrence of the provided day of the week
      newDate.setDate(newDate.getDate() + ((day + 7 - newDate.getDay()) % 7));

      // Get the dates to exclude from the countdown
      var datesToExclude = this.datesToExclude();

      // If the new date is in the dates to exclude, increment the date by one day until it's not in the dates to exclude
      while (
        datesToExclude.some(
          (dateExclude) =>
            dateExclude.getFullYear() === newDate.getFullYear() &&
            dateExclude.getMonth() === newDate.getMonth() &&
            dateExclude.getDate() === newDate.getDate()
        )
      ) {
        newDate.setDate(newDate.getDate() + 1);
      }

      // If a time is provided
      if (time) {
        // Split the time into hours and minutes
        var timeParts = time.split(':');

        // Set the hours and minutes of the new date to the provided time
        newDate.setHours(timeParts[0], timeParts[1], 0, 0);
      } else {
        // If no time is provided, log an error
        console.error('Time is undefined for day: ' + days[nextShippingDay]);
      }

      // Get the current date and time
      var now = new Date();

      // If the new date is today
      if (newDate.toDateString() === now.toDateString()) {
        // Split the threshold time into hours and minutes
        var thresholdTimeParts = this.thresholdTime.split(':');

        // Create a new date object for the threshold time
        var thresholdTime = new Date();

        // Set the hours and minutes of the threshold time
        thresholdTime.setHours(
          thresholdTimeParts[0],
          thresholdTimeParts[1],
          0,
          0
        );

        // If the current time is after the threshold time, increment the new date by one day
        if (now.getTime() > thresholdTime.getTime()) {
          newDate.setDate(newDate.getDate() + 1);
        }
      }

      // Return the new date
      return newDate;
    }

    startCountdown(nextDate, shipping, delivery) {
      // Call the getTime method to calculate and display the time remaining until the next shipping date
      this.getTime(nextDate, shipping, delivery);

      // Set an interval to call the getTime method every second
      // This will keep the countdown updated every second
      var countdownInterval = setInterval(() => {
        this.getTime(nextDate, shipping, delivery);
      }, 1000);
    }

    getTime(nextDate, shipping, delivery) {
      // Get the current date and time
      var now = new Date();

      // If the next shipping date is today
      if (nextDate.toDateString() === now.toDateString()) {
        // Define an array of days of the week
        var days = [
          'sunday',
          'monday',
          'tuesday',
          'wednesday',
          'thursday',
          'friday',
          'saturday',
        ];

        // Get the current day of the week
        var currentDay = days[now.getDay()];

        // Get the shipping time for the current day
        var thresholdTime = this.shippingData[currentDay];

        // Split the shipping time into hours and minutes
        var thresholdTimeParts = thresholdTime.split(':');

        // Create a new date object for the threshold time
        var thresholdTimeDate = new Date();

        // Set the hours and minutes of the threshold time
        thresholdTimeDate.setHours(
          thresholdTimeParts[0],
          thresholdTimeParts[1],
          0,
          0
        );

        // If the current time is after the threshold time, increment the next shipping date by one day
        if (now.getTime() > thresholdTimeDate.getTime()) {
          nextDate.setDate(nextDate.getDate() + 1);
        }
      }

      // Calculate the time remaining until the next shipping date
      var distance = nextDate.getTime() - now;
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Replace the placeholders in the original countdown text with the calculated values
      var countdownText = this.originalCountdownText;

      if (!countdownText.includes('[days]')) {
        hours += days * 24;
      }

      if (!countdownText.includes('[hours]')) {
        minutes += hours * 60;
      }

      if (!countdownText.includes('[minutes]')) {
        seconds += minutes * 60;

        if (seconds >= 60) {
          seconds = seconds % 60;
        }

        if (minutes >= 60) {
          minutes = minutes % 60;
        }
      }

      if (this.settings.hideIfZero) {
        if (days === 0) {
          countdownText = countdownText.replace(/\[days\]/g, '');
          countdownText = countdownText.replace(/\[days-string\]/g, '');
          countdownText = countdownText.replace(/\[days-string:(.*?)\]/g, '');
        }

        if (hours === 0) {
          countdownText = countdownText.replace(/\[hours\]/g, '');
          countdownText = countdownText.replace(/\[hours-string\]/g, '');
          countdownText = countdownText.replace(/\[hours-string:(.*?)\]/g, '');
        }

        if (minutes === 0) {
          countdownText = countdownText.replace(/\[minutes\]/g, '');
          countdownText = countdownText.replace(/\[minutes-string\]/g, '');
          countdownText = countdownText.replace(
            /\[minutes-string:(.*?)\]/g,
            ''
          );
        }
      }

      // Replace days template strings
      countdownText = countdownText.replace(
        /\[days-string\]/g,
        days > 1 || days === 0
          ? window.gtc.countdown.strings.days
          : window.gtc.countdown.strings.day
      );
      countdownText = countdownText.replace(/\[days-string:(.*?)\]/g, '$1');
      // Replace hours template strings
      countdownText = countdownText.replace(
        /\[hours-string\]/g,
        hours > 1 || hours === 0
          ? window.gtc.countdown.strings.hours
          : window.gtc.countdown.strings.hour
      );
      countdownText = countdownText.replace(/\[hours-string:(.*?)\]/g, '$1');
      // Replace minutes template strings
      countdownText = countdownText.replace(
        /\[minutes-string\]/g,
        minutes > 1 || minutes === 0
          ? window.gtc.countdown.strings.minutes
          : window.gtc.countdown.strings.minute
      );
      countdownText = countdownText.replace(/\[minutes-string:(.*?)\]/g, '$1');
      // Replace seconds template strings
      countdownText = countdownText.replace(
        /\[seconds-string\]/g,
        seconds > 1 || seconds === 0
          ? window.gtc.countdown.strings.seconds
          : window.gtc.countdown.strings.second
      );
      countdownText = countdownText.replace(/\[seconds-string:(.*?)\]/g, '$1');

      countdownText = countdownText.replace(/\[days\]/g, days);
      countdownText = countdownText.replace(/\[hours\]/g, hours);
      countdownText = countdownText.replace(/\[minutes\]/g, minutes);
      countdownText = countdownText.replace(/\[seconds\]/g, seconds);
      countdownText = countdownText.replace(/\[shipping\]/g, shipping);
      countdownText = countdownText.replace(/\[delivery\]/g, delivery);

      // Update the innerHTML of the element with the countdown text
      this.innerHTML = countdownText;

      // If the countdown has ended
      if (distance < 0) {
        // Stop the countdown
        clearInterval(countdownInterval);

        // Update the innerHTML of the element to indicate that the countdown has ended
        this.innerHTML = 'EXPIRED';

        // Recalculate the countdown
        this.calculateCountdown();
      }
    }
  }

  customElements.define('gtc-shipping-countdown', GtcShippingCountdown);
}
